<div class="payment-container">
  <div class="icon-container">
    @if (status_code=='0000' || status_code=='000') {
      <img src="./assets/images/congrats.png" alt="Success Icon" />
    }
    @if (status_code!='0000' && status_code!='000') {
      <img src="./assets/images/error.svg" alt="Fail Icon"  />
    }
  </div>

  <h2 class="title">Payment Status</h2>
  <!-- *ngIf="orderStatus=='success'" -->
  @if (status_code=='0000'|| status_code=='000') {
    <div>
      <p class="description">
        <!-- You have successfully booked  -->
        Your payment has been placed successfully. Please contact the dealer for further processing.
        <!-- <strong>Platinum</strong><br />
        <strong>Compressive Coverage of 25,000 kms for 4 years.</strong> -->
      </p>
      @if (payment_id) {
        <div class="reference-box">
          Reference number: <span >{{payment_id}}
          <span (click)="copyReferenceNo(payment_id)" style="cursor: pointer;">📋</span>
        </span>
      </div>
    }
  </div>
} @else {
  <div >
    <p class="description">
      We're sorry. Your booking attempt  was not successful.
    </p>
    @if (payment_id) {
      <div class="reference-box">
        Reference number: <span >{{payment_id}}
        <span (click)="copyReferenceNo(payment_id)" style="cursor: pointer;">📋</span>
      </span>
    </div>
  }
</div>
}

<!-- <hr class="divider" /> -->

<!-- <p class="support-text">
For any support, please reach to our Dealer
</p> -->
<!-- <p class="dealer-info">
📞 BAFNA Motors: <a href="javascript:void(0)">+91123456709</a>
</p> -->
<!-- <button class="btn-nvy w-50" >Back to Portfolio</button> -->
</div>